import { render, staticRenderFns } from "./NormalSearchNav584.vue?vue&type=template&id=ba54a8e4&scoped=true&"
import script from "./NormalSearchNav584.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav584.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba54a8e4",
  null
  
)

export default component.exports